
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Overlay',

  setup() {
    return {};
  },
});
